import { sidebarSlice } from './slice';

export const { toogle, open, close } = sidebarSlice.actions;

export { sidebarSlice };
